import React, {FC, useState, useEffect} from 'react';
import {navigate} from 'gatsby';
import {IPricingCard} from '../../types';
import Flag from '../pricingFlag';
import PricingItem from '../pricingItem';
import Payment from '../payment';
import CustomModal from '../../customModal';
import {Modal} from '../../modal';
import Button from '../../button';
import EmailVerification from '../../emailVerification';
import './styles.scss';

const PricingCard: FC<IPricingCard> = ({
  trigger,
  name,
  price,
  flag,
  lineThrough,
  pricingList,
  user,
  disabled,
  packeges,
  verified,
  id,
  interval,
  refetch,
  isEnterprise,
  handleEnterpriseClick,
}) => {
  //state
  const [selectedValue, setSelectedValue] = useState({
    label: '10000',
    value: 1,
  });
  const [showModal, setShowModal] = useState(false);
  const [packageInfo, setPackageInfo] = useState(null);
  const [verifyModal, setVerifyModal] = useState(false);
  //useEffects
  useEffect(() => {
    verified &&
      localStorage.getItem('packageInfo') &&
      //@ts-ignore
      setPackageInfo(JSON.parse(localStorage.getItem('packageInfo')));
  }, [verified]);
  useEffect(() => {
    if (packageInfo) {
      //@ts-ignore
      if (packageInfo.name === 'Gold') {
        //@ts-ignore
        setSelectedValue(packageInfo.selectedValue);
      }
      //@ts-ignore
      if (!disabled && packageInfo.name === name) {
        setShowModal(true);
        return;
      }
      if (
        name === 'Gold' &&
        //@ts-ignore
        packageInfo.name === 'Silver' &&
        user.pricing_package === 'GOLD'
      ) {
        !showModal && setShowModal(true);
      }
    }
  }, [packageInfo]);

  //
  const setItem = () => {
    localStorage.setItem(
      'packageInfo',
      JSON.stringify({
        name,
        price: price,
        packeges: packeges,
        selectedValue,
        id: id,
      }),
    );
  };
  const handelClick = () => {
    if (user && !user.id) {
      setItem();
      navigate('/#registration');
      return;
    }
    if (user && user.id && !verified) {
      setVerifyModal(true);
      return;
    }
    name !== 'Free' && !disabled && setShowModal(true);
  };

  const content = (
    <div className={`pricing-card position-relative m-auto ${disabled ? '' : ''}`}>
      {flag && <Flag color={flag.color} />}
      <div className="pricing-card-header">
        <div className="name">{name}</div>
        {isEnterprise ? (
          <div className="enterprice-txt text-center p-auto">Get a plan tailored to your unique business needs.</div>
        ) : (
          <div className={`price ${lineThrough ? 'line-through w-100' : ''}`}>
            ${interval === 'annual' ? (String(price / 12).length > 4 ? (price / 12).toFixed(2) : price / 12) : price}
            /mo
          </div>
        )}
        {isEnterprise ? (
          <div>
            <button className="enterprise-contact btn get-package " onClick={handleEnterpriseClick}>
              Contact us
            </button>
          </div>
        ) : (
          <div className={`${name === 'Free' || (name === 'Bronze' && interval === 'ltd') ? 'invisible' : 'visible'}`}>
            <button className="btn get-package" onClick={handelClick}>
              Buy now
            </button>
          </div>
        )}
        {!isEnterprise && (
          <div className="purchase">${name === 'Gold' ? selectedValue.value * price : price} billed upon purchase</div>
        )}
      </div>
      <div className="pricing-card-body">
        {pricingList.map((item: any) => (
          <PricingItem
            text={item.text}
            number={item.number}
            isBold={item.isBold}
            isChecked={item.isChecked}
            select={item.select}
            selectedValue={selectedValue}
            onChange={(val: any) => setSelectedValue(val)}
          />
        ))}
      </div>
    </div>
  );

  return (
    <>
      <div className={`pricing-card-container `}>
        <div className="trigger-container">
          <>
            {!!trigger && (
              <>
                <div className="pricing-trigger-wrapper">
                  {' '}
                  LIFETIME DEAL ${name === 'Gold' ? trigger * selectedValue.value : trigger}{' '}
                </div>
                <div id="triangle-down"></div>
              </>
            )}
            {content}
          </>
        </div>
      </div>
      {showModal && (
        <CustomModal ShowPopup={showModal} noCloseIcon noNavigate className="payment-modal">
          <Payment
            selectedValue={selectedValue}
            name={name}
            price={price}
            packeges={packeges}
            user={user}
            setShowPopup={setShowModal}
            id={id}
            refetch={refetch}
            interval={interval}
          />
        </CustomModal>
      )}
      {verifyModal && (
        <Modal
          isOpen={verifyModal}
          modalToggle={() => {}}
          modalFooter={
            <Button
              className="w-100"
              onClick={() => {
                setVerifyModal(false);
              }}
            >
              {' '}
              Close{' '}
            </Button>
          }
        >
          <EmailVerification />
        </Modal>
      )}
    </>
  );
};

export default PricingCard;
